import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card } from "primereact/card";
import { confirmDialog } from "primereact/confirmdialog";

import ApproverDropdown from "./ApproverDropdown";
import { changeApprover } from "../tickets/ticketsApi";
import { TicketStatusEnum } from "../ticketStatuses/TicketStatus";

interface ApprovalCardProps {
  ticketId: string;
  ticketStatus: string;
  approverId?: string;
  approverEmailAddress?: string;
  onActionFinished?: () => void;
}

export default function ApprovalCard(props: ApprovalCardProps) {
  const [selectedApproverId, setSelectedApproverId] = useState(props.approverId);
  const [selectedApproverEmailAddress, setSelectedApproverEmailAddress] = useState(props.approverEmailAddress);

  useEffect(() => {
    if (props.approverId == null && props.approverEmailAddress == null) {
      toast.warn("Atentie! Acest tichet necesita aprobare. Te rugam sa selectezi un manager inainte de a rezolva tichetul.", {
        position: "top-center",
        autoClose: 10000,
      });
    }
  }, []);

  const doChangeApprover = async (approverId?: string, approverEmailAddress?: string) => {
    if (
      props.ticketStatus !== TicketStatusEnum.New &&
      props.ticketStatus !== TicketStatusEnum.Acknowledged &&
      props.ticketStatus !== TicketStatusEnum.Escalated
    ) {
      toast.error("Tichetul trebuie sa fie in statusul 'Nou', 'In lucru' sau 'Escalat' pentru a fi schimbat managerul.");
      return;
    }

    openConfirmDialog("Schimbare manager", "Esti sigur ca vrei sa schimbi managerul?", async () => {
      if (approverId) {
        setSelectedApproverId(approverId);
        await changeApprover([props.ticketId], approverId);
      } else if (approverEmailAddress) {
        setSelectedApproverEmailAddress(approverEmailAddress);
        await changeApprover([props.ticketId], undefined, approverEmailAddress);
      }
      props.onActionFinished?.();
    });
  };

  const openConfirmDialog = async (header: string, text: string, onAccept?: () => {}, onReject?: () => void) => {
    confirmDialog({
      className: "w-almost-full md:w-4",
      icon: "pi pi-exclamation-triangle",
      header,
      message: <div className="text-xl">{text}</div>,
      acceptLabel: "Da",
      rejectLabel: "Nu",
      accept: () => onAccept?.(),
      reject: () => onReject?.(),
    });
  };

  return (
    <Card title="Aprobare tichet">
      <ApproverDropdown
        approverId={selectedApproverId}
        approverEmailAddress={selectedApproverEmailAddress}
        onChangeApproverId={(approverId) => doChangeApprover(approverId, undefined)}
        onChangeApproverEmailAddress={(approverEmailAddress) => doChangeApprover(undefined, approverEmailAddress)}
      />
    </Card>
  );
}
